import { render, staticRenderFns } from "./ThietLapKySoPhapLy.vue?vue&type=template&id=363a4163&scoped=true&"
import script from "./ThietLapKySoPhapLy.vue?vue&type=script&lang=js&"
export * from "./ThietLapKySoPhapLy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363a4163",
  null
  
)

export default component.exports